var join = function () {
    var paths = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        paths[_i] = arguments[_i];
    }
    return paths.filter(function (e) { return e; }).join("/");
};
export default {
    join: join,
};
